import { KeyboardEvent } from 'react';

type THandleEnterClick = (e: KeyboardEvent<HTMLElement>, cb: () => void) => void;

export const handleEnterClick: THandleEnterClick = ({ key }, cb) => {
  if (key === 'Enter') {
    cb();
  }
};
